import { Link } from "react-router-dom";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { ESSAY, ESSAY_TITLE } from "../content/essay";
import { Seo } from "../components/Seo";
import { ArrowRight } from "lucide-react";

export default function Story() {
  return (
    <div data-testid="story-page" className="bg-hearth-bg min-h-screen">
      <Seo
        title="Forty Years, One Bloke, & a Fire Worth Sitting Beside"
        description="The essay No BS Counselling is built on — written by someone who's watched Matt sit with people when there was nothing clever left to say."
        path="/story"
      />
      <Nav />
      <article className="pt-40 pb-24 relative grain">
        <div className="max-w-3xl mx-auto px-6">
          <p className="eyebrow mb-6">As Written by Someone Who Knows Him</p>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-hearth-ink leading-tight" data-testid="story-title">
            {ESSAY_TITLE}
          </h1>
          <div className="mt-16 space-y-0">
            {ESSAY.map((section, si) => (
              <section key={si} className="mb-14" data-testid={`story-section-${si}`}>
                {section.heading && (
                  <h2 className="font-display font-bold text-2xl sm:text-3xl text-hearth-ochre mb-8 mt-16">
                    {section.heading}
                  </h2>
                )}
                {section.paragraphs.map((p, pi) => (
                  <p
                    key={pi}
                    className={`font-essay text-lg sm:text-xl leading-loose text-hearth-ink/90 mb-6 ${si === 0 && pi === 0 ? "drop-cap" : ""}`}
                  >
                    {p}
                  </p>
                ))}
              </section>
            ))}
          </div>
          <div className="mt-20 border border-hearth-line bg-hearth-surface p-10">
            <p className="font-essay italic text-2xl text-hearth-ochre">"He's got time. Bring your whole self."</p>
            <Link
              to="/book"
              data-testid="story-book-button"
              className="mt-8 inline-flex items-center gap-3 bg-hearth-ember hover:bg-hearth-ochre hover:text-hearth-bg text-hearth-ink font-body font-semibold text-sm tracking-widest uppercase px-8 py-4 transition-colors"
            >
              Book a Session <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </article>
      <Footer />
    </div>
  );
}
